import apiClient from './client';

export interface Account {
  id: number;
  name: string;
  industry?: string;
  website?: string;
  phone?: string;
  address?: string;
  created_at: string;
  updated_at: string;
}

export interface AccountsResponse {
  success: boolean;
  data: Account[];
}

export const accountsApi = {
  getAll: async (): Promise<Account[]> => {
    const response = await apiClient.get<AccountsResponse>('/accounts');
    return response.data.data;
  },
  getById: async (id: number): Promise<Account> => {
    const response = await apiClient.get<{ success: boolean; data: Account }>(`/accounts/${id}`);
    return response.data.data;
  },
  create: async (account: Partial<Account>): Promise<Account> => {
    const response = await apiClient.post<{ success: boolean; data: Account }>('/accounts', account);
    return response.data.data;
  },
  update: async (id: number, account: Partial<Account>): Promise<Account> => {
    const response = await apiClient.patch<{ success: boolean; data: Account }>(`/accounts/${id}`, account);
    return response.data.data;
  },
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/accounts/${id}`);
  },
};

